var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#14857A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.993 5.33606C10.9244 5.34641 10.8609 5.3835 10.8132 5.44104C10.6944 5.57737 9.77567 6.66115 8.84208 7.76181C7.99665 8.75863 7.2794 9.60537 7.06344 9.8579L5.1554 8.18889C5.09155 8.13183 5.01039 8.10646 4.93006 8.11858C4.84982 8.13062 4.7771 8.17911 4.72818 8.25322C4.67925 8.32732 4.65821 8.42074 4.66975 8.51279C4.68129 8.60475 4.72445 8.68758 4.78956 8.74286L6.90881 10.5965V10.5965C6.96731 10.6471 7.03974 10.6718 7.11281 10.6658C7.18587 10.6598 7.25458 10.6236 7.30617 10.5639C7.42492 10.4276 8.3437 9.34742 9.27729 8.24684C10.2108 7.14627 11.1588 6.02517 11.2419 5.9298C11.3029 5.86159 11.336 5.76704 11.3331 5.66933C11.3303 5.57171 11.2918 5.47991 11.2271 5.41647C11.1623 5.35302 11.0773 5.32386 10.9928 5.33606L10.993 5.33606Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.b85baa759faa353a463442415b722c0c.svg";